import React from "react";

export function MicrosoftTeam() {
  return (
    <svg
      width="326"
      height="279"
      viewBox="0 0 326 279"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="MicrosoftTeam">
        <g id="Frame">
          <g id="Group">
            <path
              id="Vector"
              d="M185.98 232.094C192.465 237.335 200.715 240.479 209.702 240.479C230.566 240.479 247.48 223.565 247.48 202.701V111.869H185.979L185.98 232.094Z"
              fill="#302C89"
            />
            <path
              id="Vector 2"
              d="M209.702 97.74C226.279 97.74 239.718 84.302 239.718 67.724C239.718 51.147 226.28 37.708 209.702 37.708C200.051 37.708 191.47 42.268 185.98 49.345V86.103C191.471 93.181 200.051 97.74 209.702 97.74Z"
              fill="#302C89"
            />
            <path
              id="Vector 3"
              d="M325.136 131.331H259.904V211.565C266.761 219.635 276.98 224.753 288.386 224.753C298.367 224.753 307.931 220.761 314.949 213.666C321.967 206.571 325.854 196.963 325.745 186.985L325.136 131.331Z"
              fill="#302C89"
            />
            <path
              id="Vector 4"
              d="M287.774 117.352C304.17 117.352 317.462 104.06 317.462 87.664C317.462 71.268 304.17 57.976 287.774 57.976C271.378 57.976 258.086 71.268 258.086 87.664C258.086 104.06 271.378 117.352 287.774 117.352Z"
              fill="#302C89"
            />
          </g>
          <path
            id="Exclude"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M173.486 278.188L0 247.751V30.437L173.486 0V278.188ZM95.203 108.896H121.083L121.082 93.363H53.704V108.896H79.584V184.509H95.203V108.896Z"
            fill="#302C89"
          />
        </g>
      </g>
    </svg>
  );
}
